import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Card, Tag, message, Spin, Form, Input } from 'antd';
import { api } from '../../contexts/AuthContext';

const { TextArea } = Input;

const OrderReview = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectOrderId, setRejectOrderId] = useState(null);
  const [rejectForm] = Form.useForm();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await api.get('/admin/orders/pending');
      setOrders(response.data.orders);
    } catch (error) {
      message.error('获取待审核订单失败');
      console.error('获取待审核订单失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleReview = async (orderId, approved, rejectReason = '') => {
    try {
      await api.post(`/admin/orders/${orderId}/review`, { approved, reject_reason: rejectReason });
      message.success(approved ? '订单审核通过' : '订单审核未通过');
      fetchOrders();
    } catch (error) {
      message.error('审核失败');
      console.error('审核失败:', error);
    }
  };

  const handleRejectClick = (orderId) => {
    setRejectOrderId(orderId);
    setRejectModalVisible(true);
    rejectForm.resetFields();
  };

  const handleRejectSubmit = () => {
    rejectForm.validateFields().then((values) => {
      handleReview(rejectOrderId, false, values.reject_reason);
      setRejectModalVisible(false);
      rejectForm.resetFields();
    }).catch(() => {});
  };

  const viewOrder = (order) => {
    setSelectedOrder(order);
    setModalVisible(true);
  };

  const columns = [
    {
      title: '订单编号',
      dataIndex: 'uuid',
      key: 'uuid',
      ellipsis: true,
      width: 150,
    },
    {
      title: '任务名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
    },
    {
      title: '发布者',
      dataIndex: 'company_user',
      key: 'company_user',
      render: (user) => user?.nickname || '-',
    },
    {
      title: '风格',
      dataIndex: 'style',
      key: 'style',
      width: 100,
    },
    {
      title: '时长',
      dataIndex: 'duration_minutes',
      key: 'duration_minutes',
      width: 80,
      render: (val) => `${val}分钟`,
    },
    {
      title: '预算',
      dataIndex: 'total_price',
      key: 'total_price',
      width: 100,
      render: (val) => `${val}积分`,
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 160,
      render: (val) => val ? new Date(val).toLocaleString('zh-CN') : '-',
    },
    {
      title: '操作',
      key: 'action',
      width: 200,
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Button size="small" onClick={() => viewOrder(record)}>查看详情</Button>
          <Button size="small" type="primary" onClick={() => handleReview(record.id, true)}>审核通过</Button>
          <Button size="small" danger onClick={() => handleRejectClick(record.id)}>拒绝</Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <h2>订单审核</h2>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '50px 0' }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card>
          <Table
            dataSource={orders}
            columns={columns}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            locale={{ emptyText: '暂无待审核订单' }}
          />
        </Card>
      )}

      <Modal
        title="订单详情"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={800}
      >
        {selectedOrder && (
          <div>
            <h3>{selectedOrder.title}</h3>
            <p><strong>描述：</strong>{selectedOrder.description}</p>
            <p><strong>风格：</strong>{selectedOrder.style}</p>
            <p><strong>时长：</strong>{selectedOrder.duration_minutes}分钟</p>
            <p><strong>预算：</strong>{selectedOrder.total_price}积分</p>
            <p><strong>交付周期：</strong>{selectedOrder.delivery_days}天</p>
            <p><strong>视频方向：</strong>{selectedOrder.video_orientation}</p>
            <p><strong>视频比例：</strong>{selectedOrder.video_ratio}</p>
            <div style={{ marginTop: 16 }}>
              <strong>剧本内容：</strong>
              <p style={{ whiteSpace: 'pre-wrap' }}>{selectedOrder.script_content}</p>
            </div>
            {selectedOrder.assets_description && (
              <div style={{ marginTop: 16 }}>
                <strong>资产要求：</strong>
                <p>{selectedOrder.assets_description}</p>
              </div>
            )}
          </div>
        )}
      </Modal>

      <Modal
        title="拒绝订单"
        visible={rejectModalVisible}
        onCancel={() => setRejectModalVisible(false)}
        onOk={handleRejectSubmit}
        okText="确认拒绝"
        cancelText="取消"
      >
        <Form form={rejectForm} layout="vertical">
          <Form.Item
            name="reject_reason"
            label="拒绝理由"
            rules={[{ required: true, message: '请填写拒绝理由' }]}
          >
            <TextArea rows={4} placeholder="请输入拒绝理由，以便发布者了解问题所在" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default OrderReview;